import script from "./PageInstitutionalSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageInstitutionalSearch.vue?vue&type=script&setup=true&lang=ts"

import "./PageInstitutionalSearch.vue?vue&type=style&index=0&id=7fcc5438&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fcc5438"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QInput,QIcon,QBtn,QTable,QTr,QTh,QCheckbox,QTd,QPopupProxy,QBanner,QCard,QSelect});
